import { render } from "./GestaoPage.vue?vue&type=template&id=b4145338&scoped=true"
import script from "./GestaoPage.vue?vue&type=script&lang=js"
export * from "./GestaoPage.vue?vue&type=script&lang=js"

import "./GestaoPage.vue?vue&type=style&index=0&id=b4145338&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4145338"]])

export default __exports__